import React from 'react';
interface HabbitLogoProps {
  size?: number;
  className?: string;
}
export function HabbitLogo({
  size = 32,
  className = ''
}: HabbitLogoProps) {
  // A clean, geometric upward streak/staircase representing consistency and growth
  return <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} data-id="element-156">
      <rect x="4" y="20" width="6" height="8" rx="2" fill="#F59E0B" fillOpacity="0.4" data-id="element-157" />
      <rect x="13" y="12" width="6" height="16" rx="2" fill="#F59E0B" fillOpacity="0.7" data-id="element-158" />
      <rect x="22" y="4" width="6" height="24" rx="2" fill="#F59E0B" data-id="element-159" />
    </svg>;
}